export const getStarFillAmount = (star: number, effectiveRating: number) => {
  const fullStars = Math.floor(effectiveRating);
  const partialStar = effectiveRating - fullStars;

  if (star <= fullStars) return 1;
  if (star === fullStars + 1) return partialStar;
  return 0;
};
